import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTreeview } from 'vuetify/lib/components/VTreeview';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTreeview,{attrs:{"activatable":"","items":_vm.treeProductsArray,"open-on-click":"","transition":"","load-children":_vm.fetchProductItems,"color":"primary","return-object":""},on:{"update:active":_vm.openMetadata},scopedSlots:_vm._u([{key:"append",fn:function({ item }){return [(!item.children)?_c(VBtn,{attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.zoomToProductAoi(item.extent)}}},[_c(VIcon,[_vm._v("mdi-magnify-expand")])],1):_vm._e()]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }